<template>
    <div class="absolute top-14 left-8">
        <router-link :to="to" >
            <i class="text-2xl fas fa-arrow-alt-circle-left"></i>
        </router-link>
    </div>
</template>
<script>
export default {
    props: ['to']
}
</script>